<template>
  <v-breadcrumbs class="ma-0 pa-0" :items="breadCrumbList"></v-breadcrumbs>
</template>
<script>
export default {
  computed: {
    breadCrumbList() {
      const list = [];

      const routeList = this.$route.matched;

      routeList.forEach(route => {
        const { meta: { breadcrumb } = {} } = route;

        if (breadcrumb) {
          const {
            name,
            meta: { breadcrumb: text },
          } = route;
          const { params } = this.$route;

          list.push({
            exact: true,
            text,
            to: { name, params },
          });
        }
      });

      return list;
    },
  },
};
</script>
